import { Controller } from "@hotwired/stimulus"
import { getCloudFrontKeyPairId } from "../vendor/cloudfront-utils.js"

// Connects to data-controller="passage-image-loader"
// Loads images from CloudFront CDN and sets dimensions
export default class extends Controller {
  static values = {
    itemUrl: String,
    policy: String,
    signature: String,
    keyPairId: String  // Optional - falls back to meta tag if not provided
  }

  // Get keyPairId from data attribute if provided, otherwise from meta tag
  get keyPairId() {
    return this.hasKeyPairIdValue ? this.keyPairIdValue : getCloudFrontKeyPairId()
  }

  connect() {
    this.loadImage()
  }

  loadImage() {
    if (!this.hasItemUrlValue) return

    // Extract item ID from URL (e.g., "Questions/123.png" -> "123")
    // Match the script logic: replace(".png", "").split('/')[1]
    const item = this.itemUrlValue.replace(".png", "").split('/')[1]
    const cover = document.getElementById(item)
    const target = document.getElementById(item + "-alt")

    if (!cover || !target) {
      console.warn(`Could not find elements for item: ${item}`)
      return
    }

    // Build CloudFront signed URL
    const imageUrl = `https://cdn.lsatengine.com/Questions/${this.itemUrlValue}?Policy=${this.policyValue}&Signature=${this.signatureValue}&Key-Pair-Id=${this.keyPairId}`
    target.src = imageUrl

    // Set dimensions when image loads
    target.onload = () => {
      const newWidth = target.naturalWidth / 2
      const imgWrap = document.getElementById('img-wrap-' + item)

      if (imgWrap) {
        window.$(imgWrap).width(newWidth)
      }

      window.$(target).width(newWidth)
      window.$(cover).width(newWidth)
      window.$(cover).height(target.naturalHeight / 2)
    }
  }
}
